import { RouteObject } from '@rocketlane/rocket-router';
import { ErrorBoundary } from 'components/molecules/error-boundary';
import { ErrorBoundaryFallback } from 'components/molecules/error-boundary/fallback';
import { SecureRoute } from 'routes/route-with-permission-check';
import { ROUTE_PATHS } from 'routes/routes-paths';
import { lazyWithRetry } from 'utils/lazyWithRetry';

// Real dynamic import — pulls SprintPlanningRouteComponent (and through it
// the entire sprint-planning organism: BacklogDetails, EpicDashboard,
// NewSprint, SprintDashboard, etc.) into a route-scoped chunk instead of
// the app shell. Previously this file inlined the component AND the lazy
// wrapper, so the route was eagerly imported by app-routes.tsx and
// pulled ~226 kB of tasks-organism transitive deps into the shell.
const LazySprintPlanningRoute = lazyWithRetry(() =>
  import('./sprint-planning-route-component').then((m) => ({
    default: m.SprintPlanningRouteComponent,
  })),
);

export const sprintRoutes: RouteObject = {
  path: `${ROUTE_PATHS.SPRINT_PLANNING}/${ROUTE_PATHS.MATCH_ALL}`,
  element: (
    <ErrorBoundary fallback={ErrorBoundaryFallback}>
      <SecureRoute>
        <LazySprintPlanningRoute />
      </SecureRoute>
    </ErrorBoundary>
  ),
};
